module.exports = __webpack_public_path__ + "static/media/loader.2d523c5e.svg";